const button = document.querySelector(".btn-page-top");

if (button) {
  // 基本の bottom 値を CSS から取得（px）
  const getBaseBottom = () => {
    const cs = window.getComputedStyle(button);
    const val = parseFloat(cs.bottom);
    return Number.isFinite(val) ? val : 20;
  };

  let baseBottom = getBaseBottom();

  const getFooter = () =>
    document.getElementById("footer") ||
    document.querySelector("#footer, footer");

  const updatePosition = () => {
    const footer = getFooter();
    if (!footer) return;

    const footerTop = footer.getBoundingClientRect().top;
    const winH = window.innerHeight;
    const btnH = button.offsetHeight || 0;

    // 中央Yが footer 上端を下回らないように bottom を増やす
    const neededBottom = Math.max(baseBottom, winH - footerTop - btnH / 2);
    // 0未満は発生しないが、念のため丸め
    button.style.bottom = `${Math.max(0, Math.round(neededBottom))}px`;
  };

  const onScroll = () => {
    if (window.scrollY > 100) {
      button.classList.add("is-active");
    } else {
      button.classList.remove("is-active");
    }
    updatePosition();
  };

  const onResize = () => {
    baseBottom = getBaseBottom();
    updatePosition();
  };

  button.addEventListener("click", () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  });

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize);

  // 初期配置
  onResize();
  onScroll();
}
